import React, { useState, useEffect, memo } from 'react';
import { getCurrentScore } from '../../../../service/backend-api-service';

const LiveScore = memo((props) => {
    const [score, setScore] = useState("-")

    useEffect(() => {
        const fetchData = async () => {
            if (score == "-" || score.status.longName != 'Match Finished') {
                let eventId = props.eventId;
                let scoreAjax = await getCurrentScore(eventId)
                props.matchStatusChangeHandler(eventId, scoreAjax)
                setScore(scoreAjax)
            }
        }
        fetchData();
        const interval = setInterval(() => fetchData() , 5 * 1000 * 60  );
       
        return () => clearInterval(interval);
    }, [props.eventId, props.date])


    const formatGoal = (home, away) =>{
        if((home === null && away === null) || (home === -1 && away === -1)){
            return '- -';
        }
        return home + "-" + away;
    }

    return (
        score !== '-' ?
            <div style={{ display: "flex" }}>
                <div style={{ minWidth: "30px" }}>
                    {score.goal?
                        formatGoal(score.goal.home,score.goal.away) : "-"}
                </div>
                <div style={{ marginLeft: "5px", minWidth: "75px" }}>
                    {score.status && score.status.longName ?
                        ((score.status.elapsed > 84 &&  score.status.longName === 'SecondHalfKickOff') ? 'Match Finished' : score.status.longName) : ""}
                </div>
                <div style={{ marginLeft: "5px", minWidth: "25px", textAlign: "left" }}>
                    {score.status && score.status.longName !== 'Match Finished' && score.status.elapsed ?
                        score.status.elapsed : ""}
                </div>
                <div style={{ marginLeft: "5px", minWidth: "30px" }}>
                    {score.score && score.score.halftime ?
                        formatGoal(score.score.halftime.home,score.score.halftime.away) : "-"}
                </div>
            </div> : <> Loading...</>

    )
})

export default LiveScore;